module.exports = __webpack_public_path__ + "4cadf81c806cf337dbe8a32c5cc23915.MP3";